// Image Preloader Utility
export const preloadImages = (images: string[]) => {
  // Return a promise that resolves when all images are loaded
  return Promise.all(
    images.map((image) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(image);
        img.onerror = () => reject(new Error(`Failed to load ${image}`));
        img.src = image;
      });
    })
  );
};
